import * as React from 'react';

import {ServiceStatus} from '../../modules/servicestatus/types';

type Props = {
	activeFilter: string | null | undefined;
	platformStatus: Array<ServiceStatus> | null | undefined;
	filterServices: (status: string) => void;
};

const STATUS = ['UP', 'UNKNOWN', 'OFFLINE'];
const ServiceStatusOverview = ({activeFilter, platformStatus, filterServices}: Props) => {
	return (
		<React.Fragment>
			{STATUS.map<React.ReactNode>((s) => {
				const filteredStatus = (platformStatus || []).filter((status) => s === status.status);
				const counterClass = filteredStatus.length > 0 ? 'counter' : 'counter isZero';
				return (
					<div className="dash-box-holder" key={s} onClick={() => filterServices(s)}>
						<div className={activeFilter === s ? `dash-box status-${s} selected` : `dash-box status-${s}`}>
							<div className="dash-box-head" data-testid={`statuspage-overview-head-${s}`}>
								{s}
							</div>
							<div className="dash-box-cont" data-testid="statuspage-overview-head-content">
								<div className={counterClass}>{filteredStatus.length}</div>
							</div>
						</div>
					</div>
				);
			})}
		</React.Fragment>
	);
};

export default ServiceStatusOverview;
